module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/avorontsov/WebstormProjects/tab/~/axios/index.js
// module id = 12
// module chunks = 0